<script lang="ts" setup>
import type { TTeacherProfile } from "@/assets/js/globalTypes";

import api from "@/api";
import { useSessionStore } from "@/store/session";

definePage({
	name: "teacher.public-profile",
});

const isLoading = ref(false);
const teacherData = ref<TTeacherProfile | null>(null);

async function getTeacherData(id: number) {
	isLoading.value = true;

	try {
		const res = await api.getTeacher(id);
		teacherData.value = res.data.data;
	} catch (error) {
		console.error(error);
	} finally {
		isLoading.value = false;
	}
}
const sessionStore = useSessionStore();
onMounted(() => {
	getTeacherData(Number(sessionStore.userId));
});
</script>

<template>
	<div id="teacher-indivual-profile">
		<template v-if="isLoading && !teacherData">
			<div class="progress-spinner">
				<p-progress-spinner />
			</div>
		</template>
		<template v-else-if="!isLoading && !teacherData">
			{{ $t("app.base.no-results") }}
		</template>
		<template v-else>
			<individual-profile-top
				:can-book="false"
				:teacher-data="teacherData"
			/>
			<individual-profile-bottom :teacher-data="teacherData" />
		</template>
	</div>
</template>

<style lang="scss" scoped>
#teacher-indivual-profile {
	padding: 20px 16px;
	box-sizing: border-box;
	max-height: calc(100vh - $nav-top-bar - 1px);
	overflow-y: auto;

	.progress-spinner {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 200px;
	}
}
</style>
